import React, { useEffect, useState } from "react";
import { Form, FloatingLabel } from "react-bootstrap";
import RichTextEditor from "../RichTextEditor";

interface ContentFormProps {
  image: File[]; // Array of images
  ticket_group_code: string; // Album name
  warningMessage?: string;
  items: Item[];
  onImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void; // Handler for image changes
  onTicketGroupCodeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void; // Handler for album name change
}

interface Item {
  ticket_id: number;
  ticket_group_code: string;
  // Add more properties as per your item structure
}

export default function UpdatedSeatPlanForm({
  items,
  image,
  ticket_group_code,
  warningMessage,
  onImageChange,
  onTicketGroupCodeChange,
}: ContentFormProps) {
  return (
    <>
      <Form.Group className="mb-3" controlId="formImage">
        <Form.Label className="text-sm mb-2">Images</Form.Label>
        <Form.Control type="file" multiple onChange={onImageChange} />

        {warningMessage && (
          <div style={{ color: "red", marginBottom: "10px" }}>
            {warningMessage}
          </div>
        )}
      </Form.Group>

      {/* Display Existing Images */}
      <Form.Group className="mb-3" controlId="formExistingImages">
        <Form.Label className="text-sm mb-2">Existing Images</Form.Label>
        <div className="existing-images">
          {image.map((img, index) => (
            <div key={index} style={{ marginBottom: "10px" }}>
              <img
                src={typeof img === "string" ? img : URL.createObjectURL(img)}
                alt={`Existing ${index + 1}`}
                style={{ width: "100px", height: "100px", objectFit: "cover" }}
              />
            </div>
          ))}
        </div>
      </Form.Group>

      {/* Ticket Group Code */}
      <Form.Group className="mb-3" controlId="formCategory">
        <label className="text-sm mb-2">Ticket Group Code</label>
        <Form.Select
          aria-label="Select Category"
          className="bg-gray-200"
          value={ticket_group_code}
          onChange={onTicketGroupCodeChange}
        >
          <option value="ticket_group_code">{ticket_group_code}</option>
          {/* {items.map((item) => (
            <option key={item.ticket_id} value={item.ticket_group_code}>
              {item.ticket_group_code}
            </option>
          ))} */}
        </Form.Select>
      </Form.Group>
    </>
  );
}
